if (!customElements.get('discount-tag')) {
    class DiscountTag extends StorePrice {
    constructor() {
        super();
        this.discountTagDom = this.querySelector('[data-discount-tag-value]');
    }

    connectedCallback() {
        super.connectedCallback();
    }

    renderPrice() {
        // console.log('DiscountTag renderPrice called');
        const currentStorePrice = this.storesPrice[this.currentStoreCode];

        if (currentStorePrice && currentStorePrice.onSale === 'Y') {
            const diff = currentStorePrice?.regionPrice - currentStorePrice?.webPrice;

            if (diff > 0) {
                const discountPercent = Math.round((diff / currentStorePrice?.regionPrice) * 100);
                this.discountTagDom.textContent = `Up to ${discountPercent}% off`;
            } else {
            this.discountTagDom.textContent = '';
            }
        }
    }
    }

    customElements.define('discount-tag', DiscountTag);
}